// extracted by mini-css-extract-plugin
export default {"indicator":"OnlineIndicator_indicator__++kw8","online":"OnlineIndicator_online__wOBdz"};